import React, { Component} from 'react';
import LoginForm from './Subcomponents/LoginForm';
import withRouter from './Functions/WithRouter';

class EmpSignUpOrg extends Component {
    constructor(props) {
      super(props)
      this.state = {
      }
    }

    componentDidMount() {
      console.log('sign up page is mounting')

      //user navigated from a landing page or from the app
      const { emp, org } = this.props.params
      this.setState({ emp, orgCode: org })
    }

    render() {

      return (
        <div>
          <LoginForm roleName="Employer" orgCode={this.state.orgCode} courseId={this.state.courseId} accountCode={this.state.emp} fromExternal={this.state.fromExternal} history={this.props.navigate} type="SignUp" />
        </div>
      )
    }
}

export default withRouter(EmpSignUpOrg)
